 <template>
  <page-with-aside :hasFooter="true">
    <header class="page-header">
      <!-- already logged in so hide login button -->
      <nav>
        <router-link to="/about" class="button">About the Program</router-link>
      </nav>
    </header>

    <template #content>
      <section class="content">
        <h2>Set up your account</h2>

        <form class="account" ref="form" @submit="handleSubmit">
          <section>
            <div class="group">
              <p>
                <strong>Set up log in information</strong>
              </p>

              <!-- email input-->
              <label class="col-md-4 control-label" for="email"
                >Email Address</label
              >
              <p class="help-block">This will be your user name to log in.</p>           

              <input
                id="email"
                type="email"
                name="email"
                placeholder="you@example.com"
                class="form-control input-md"
                required
              />

              <!-- Password input-->
              <label class="col-md-4 control-label" for="passwordinput"
                >Password</label
              >
              <input
                id="password1"
                name="password1"
                type="password"
                placeholder="password"
                class="form-control input-md"
                required
              />
              <!-- Password confirm input-->
              <label class="col-md-4 control-label" for="passwordinput"
                >Confirm your password</label
              >
              <input
                id="password2"
                name="password2"
                type="password"
                placeholder="password again"
                class="form-control input-md"
                required
              />
            </div>
            <div class="group">
              <p>
                <strong>Personal Info</strong>
              </p>
              <!-- First name -->
              <ul
                v-for="(firstNameError, firstNameErrorIndex) in firstNameErrors"
                :key="'firstNameError_' + firstNameErrorIndex"
              >
                <li v-html="firstNameError" />
              </ul>
              <label for="first_name">First Name</label>
              <input
                id="first_name"
                name="first_name"
                type="text"
                placeholder="First Name"
                required
              />
              <!-- Last name -->
              <ul
                v-for="(lastNameError, lastNameErrorIndex) in lastNameErrors"
                :key="'lastNameError_' + lastNameErrorIndex"
              >
                <li v-html="lastNameError" />
              </ul>
              <label for="last_name">Last Name</label>
              <input
                id="last_name"
                name="last_name"
                type="text"
                placeholder="Last Name"
                required
              />
              <!-- Phone -->
              <label for="phone">Phone Number</label>
              <p class="help-block">
                This will only be used if the study coordinator needs to reach
                you. We won't share your phone number with anyone outside of the
                study team.
              </p>
              <input
                id="phone"
                name="phone"
                type="tel"
                placeholder="(999) 999-9999"
              />

              <ul
                v-for="(phoneError, phoneErrorIndex) in phoneErrors"
                :key="'phoneError_' + phoneErrorIndex"
              >
                <li v-html="phoneError" />
              </ul>
            </div>
            <div class="group">
              <!-- gender -->
              <ul
                v-for="(genderError, genderErrorIndex) in genderErrors"
                :key="'genderError_' + genderErrorIndex"
              >
                <li v-html="genderError" />
              </ul>
              <label class="col-md-4 control-label" for="gender">
                <strong>What is your gender?</strong>
              </label>
              <div class="form-group">
                <div class="radio">
                  <label for="gender-0">
                    <input
                      type="radio"
                      name="gender"
                      id="gender-0"
                      value="Female"
                      required
                    />
                    Female
                  </label>
                </div>
                <div class="radio">
                  <label for="gender-1">
                    <input
                      type="radio"
                      name="gender"
                      id="gender-1"
                      value="Male"
                      required
                    />
                    Male
                  </label>
                </div>
                <div class="radio">
                  <label for="gender-2">
                    <input
                      type="radio"
                      name="gender"
                      id="gender-2"
                      value="TransgenderFemale"
                      required
                    />
                    Transgender female
                  </label>
                </div>
                <div class="radio">
                  <label for="gender-3">
                    <input
                      type="radio"
                      name="gender"
                      id="gender-3"
                      value="TransgenderMale"
                      required
                    />
                    Transgender male
                  </label>
                </div>
                <div class="radio">
                  <label for="gender-4">
                    <input
                      type="radio"
                      name="gender"
                      id="gender-4"
                      value="GenderNonConforming"
                      required
                    />
                    Gender non-conforming
                  </label>
                </div>
                <div class="radio">
                  <label for="gender-5">
                    <input
                      type="radio"
                      name="gender"
                      id="gender-5"
                      value="Other"
                      required
                    />
                    Other
                  </label>
                </div>
                <div class="radio">
                  <label for="gender-6">
                    <input
                      type="radio"
                      name="gender"
                      id="gender-6"
                      value="PreferNot"
                      required
                    />
                    Prefer not to answer
                  </label>
                </div>
              </div>
            </div>
            <div class="group">
              <!-- education -->
              <ul
                v-for="(educationError, educationErrorIndex) in educationErrors"
                :key="'educationError_' + educationErrorIndex"
              >
                <li v-html="educationError" />
              </ul>
              <label class="col-md-4 control-label" for="education">
                <strong
                  >What is the highest level of education you have
                  completed?</strong
                >
              </label>
              <div class="form-group">
                <div class="radio">
                  <label for="education-0">
                    <input
                      type="radio"
                      name="education"
                      id="education-0"
                      value="LessThanHighSchool"
                      required
                    />
                    Less than high school
                  </label>
                </div>
                <div class="radio">
                  <label for="education-1">
                    <input
                      type="radio"
                      name="education"
                      id="education-1"
                      value="HighSchool"
                      required
                    />
                    High school graduate
                  </label>
                </div>
                <div class="radio">
                  <label for="education-2">
                    <input
                      type="radio"
                      name="education"
                      id="education-2"
                      value="SomeCollege"
                      required
                    />
                    Some college
                  </label>
                </div>
                <div class="radio">
                  <label for="education-3">
                    <input
                      type="radio"
                      name="education"
                      id="education-3"
                      value="College"
                      required
                    />
                    College graduate
                  </label>
                </div>
                <div class="radio">
                  <label for="education-4">
                    <input
                      type="radio"
                      name="education"
                      id="education-4"
                      value="SomeGraduateSchool"
                      required
                    />
                    Some graduate school
                  </label>
                </div>
                <div class="radio">
                  <label for="education-5">
                    <input
                      type="radio"
                      name="education"
                      id="education-5"
                      value="GraduateSchool"
                      required
                    />
                    Completed graduate school
                  </label>
                </div>
                <div class="radio">
                  <label for="education-6">
                    <input
                      type="radio"
                      name="education"
                      id="education-6"
                      value="PreferNot"
                      required
                    />
                    Prefer not to answer
                  </label>
                </div>
              </div>
            </div>
            <div class="group">
              <!-- race -->
              <ul
                v-for="(raceError, raceErrorIndex) in raceErrors"
                :key="'raceError_' + raceErrorIndex"
              >
                <li v-html="raceError" />
              </ul>
              <label class="col-md-4 control-label" for="Race">
                <strong
                  >Which of the following best describes your race? Please mark
                  ALL that apply.</strong
                >
              </label>
              <div class="form-group">
                <div class="checkbox">
                  <label for="Race-0">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-0"
                      value="white"
                    />
                    White
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-1">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-1"
                      value="black"
                    />
                    Black or African American
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-2">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-2"
                      value="american_indian"
                    />
                    American Indian or Alaska Native
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-3">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-3"
                      value="native_hawaiian"
                    />
                    Native Hawaiian or Other Pacific Islander
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-4">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-4"
                      value="middle_eastern"
                    />
                    Middle Eastern
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-5">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-5"
                      value="indian"
                    />
                    Asian Indian
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-6">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-6"
                      value="chinese"
                    />
                    Chinese
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-7">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-7"
                      value="filipino"
                    />
                    Filipino
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-8">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-8"
                      value="japanese"
                    />
                    Japanese
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-9">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-9"
                      value="korean"
                    />
                    Korean
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-10">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-10"
                      value="vietnamese"
                    />
                    Vietnamese
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-11">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-11"
                      value="other_asian"
                    />
                    Other Asian
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-12">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-12"
                      value="other"
                    />
                    Other Race
                  </label>
                </div>
                <div class="checkbox">
                  <label for="Race-13">
                    <input
                      type="checkbox"
                      name="race"
                      id="Race-13"
                      value="prefer_not"
                    />
                    Prefer not to answer
                  </label>
                </div>
              </div>
            </div>
            <div class="group">
              <!-- ethnicity -->
              <label class="col-md-4 control-label" for="ethnicity">
                <strong>What is your ethnicity? Please choose one.</strong>
              </label>
              <div class="form-group">
                <div class="radio">
                  <label for="ethnicity-0">
                    <input
                      type="radio"
                      name="ethnicity"
                      id="ethnicity-0"
                      value="Hispanic"
                      required
                    />
                    Hispanic or Latino
                  </label>
                </div>
                <div class="radio">
                  <label for="ethnicity-1">
                    <input
                      type="radio"
                      name="ethnicity"
                      id="ethnicity-1"
                      value="NotHispanic"
                      required
                    />
                    Not Hispanic or Latino
                  </label>
                </div>
                <div class="radio">
                  <label for="ethnicity-2">
                    <input
                      type="radio"
                      name="ethnicity"
                      id="ethnicity-2"
                      value="PreferNot"
                      required
                    />
                    Prefer not to answer
                  </label>
                </div>
              </div>
            </div>
            <!--end group-->
          </section>
          <!--must be above submit-->

          <ul
            v-for="(error, errorIndex) in errors"
            :key="'error_' + errorIndex"
          >
            <li v-html="error" />
          </ul>

          <input
            type="submit"
            value="Submit"
          /><!--mike clicking this needs to go to onboarding first if in intervention, but to survey if in control-->
        </form>
      </section>
    </template>
  </page-with-aside>
</template>
 
 <style scoped lang="scss">
.help-block {
  font-style: italic;
  color: #158172;
}
.radio-inline {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  input {
    width: 2em;
  }
}
.citystatezip {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .city,
  .state,
  .zip {
    flex-basis: 100%;
  }

  @media (min-width: 600px) {
    .city {
      flex: 1;
      padding-right: 1rem;
    }
    .state {
      flex: initial;
      padding-right: 1rem;
      input {
        max-width: 6ch;
      }
    }
    .zip {
      flex: initial;
      input {
        max-width: 9ch;
      }
    }
  }
}
.form-group {
  label {
    display: flex;
    align-content: flex-start;
    padding-right: 2rem;
    input {
      margin: 0 1rem 0 0;
      flex: initial;
    }
    input[type="radio"],
    input[type="checkbox"] {
      width: auto;
      margin-right: 0.5rem;
    }
  }
  @media (max-width: 800px) {
    .radio,
    .checkbox {
      flex-basis: 50%;
    }
  }
}
input[type="submit"] {
  width: auto;
}
input[type="text"],
input[type="tel"],
input[type="password"],
input[type="email"] {
  max-width: 600px;
}
</style>
 
 
 <script>
import PageWithAside from "@/components/PageWithAside.vue";
import { axios } from "@/main.js";
import { mapMutations } from "vuex";

export default {
  name: "AccountSetup",
  components: {
    PageWithAside,
  },
  props: {
    accessCode: String,
  },

  data() {
    return {
      accessCodeErrors: null,
      errors: [],
      emailErrors: [],
      passwordErrors: [],
      firstNameErrors: [],
      lastNameErrors: [],
      phoneErrors: [],
      genderErrors: [],
      educationErrors: [],
      raceErrors: [],
      ethnicityErrors: [],
    };
  },
  methods: {
    ...mapMutations(["setAccessCode", "setArm", "setServerChatSessionID"]),

    clearErrors() {
      this.errors = [];
      this.passwordErrors = [];
      this.emailErrors = [];
      this.phoneErrors = [];
      this.genderErrors = [];
      this.raceErrors = [];
      this.ethnicityErrors = [];
    },

    handleSubmit(event) {
      event.preventDefault();
      this.sendNewAccountData();
    },

    sendNewAccountData() {
      this.clearErrors();
      let formData = new FormData(this.$refs.form);
      let self = this;

      if (!formData.get("password1")) {
        this.errors.push("Please enter a password");
        return;
      }

      if (formData.get("password1") != formData.get("password2")) {
        this.errors.push("Please make sure your passwords match.");
        return;
      }

      let races = formData.getAll("race");
      // these have to match values in the form and on the backend
      let allRaces = [
        "white",
        "black",
        "american_indian",
        "native_hawaiian",
        "middle_eastern",
        "indian",
        "chinese",
        "filipino",
        "japanese",
        "korean",
        "other_asian",
        "vietnamese",
        "other",
        "prefer_not",
      ];

      for (let raceIndex in allRaces) {
        let race = allRaces[raceIndex];
        if (races.indexOf(race) >= 0) {
          formData.set("race_" + race, "1");
        } else {
          formData.set("race_" + race, "0");
        }
      }

      formData.set("password", formData.get("password1"));

      let url = "/api/register/" + this.accessCode + "/";

      axios
        .put(url, formData)
        .then(function (response) {
          let status = response.status;

          switch (status) {
            case 200:
              // save valid access code locally
              self.setAccessCode(self.accessCode);

              // let arm = response.data["arm"];
              // self.setArm(arm);
              self.setServerChatSessionID(response.data["session_id"]);

              // Redirect based on arm.
              // TODO fix based on deployment.
              // Dev: DJANGO_QUALTRICS_CONTROL_URL=https://umich.qualtrics.com/jfe/form/SV_9uzdYJa5DUhXSiF

              // Prod: DJANGO_QUALTRICS_CONTROL_URL=https://umich.qualtrics.com/jfe/form/SV_2rhAyVR1wlYCHUF

              // if (arm == "C") {
              //   window.location.href =
              //     "https://umich.qualtrics.com/jfe/form/SV_2rhAyVR1wlYCHUF?StudyID=" +
              //     self.accessCode;
              // } else {
              //   self.$router.push("/onboarding/");
              // }
              self.$router.push("/onboarding/");
              break;

            default:
              break;
          }
        })
        .catch(function (error) {
          let status = error.response.status;
          self.errors.push[error.response.statusText];
          switch (status) {
            case 400: // bad request
              self.emailErrors = error.response.data["email"];
              self.passwordErrors = error.response.data["password"];
              self.phoneErrors = error.response.data["phone"];
              self.genderErrors = error.response.data["gender"];
              self.raceErrors = error.response.data["race"];
              self.ethnicityErrors = error.response.data["ethnicity"];

              self.errors = error.response.data;

              break;

            default:
              break;
          }
        });
    },

    goToChat() {
      this.$router.push("/chat/situation/new/");
      this.changeMode("chat");
    },
  },
};
</script>